import { GrGithub } from 'react-icons/gr'
import { TbWorld } from 'react-icons/tb'

// images from the asset folder in the image file


import Abhishar01 from '../../assets/images/abhishar01.png'
import Abhishar02 from '../../assets/images/abhishar02.png'
import Abhishar03 from "../../assets/images/Abhishar03.png";
import Abhishar04 from "../../assets/images/Abhishar04.png";

export const pages = [
  {
    id: 1,
    name: "Special Theme Page",
    // desc:
    //   'A game that gives you 5 attempts to guess the correct word of the day',

    imgUrl: Abhishar01,
  },
  {
    id: 2,
    name: "Memories page",
    // desc: 'A Responsive restaurant website design with great UI Effect',

    imgUrl: Abhishar02,
  },
  {
    id: 3,
    name: "Content page",
    // desc: 'A Responsive restaurant website design with great UI Effect',

    imgUrl: Abhishar03,
  },
  {
    id: 4,
    name: "Content page",
    // desc: 'A Responsive restaurant website design with great UI Effect',

    imgUrl: Abhishar04,
  },
];